import Decimal from 'decimal.js';
import { deburr, kebabCase } from 'lodash';
import { DateTime } from 'luxon';

const SLICE_LENGTH = -2;

export function addZero(number: string): string {
  if (number.length === 1) {
    return ('0' + number).slice(SLICE_LENGTH);
  }
  return number;
}

export function formatIsoToDotDate(date: string): string {
  if (!date) {
    return '';
  }
  return date
      .split('-')
      .reverse()
      .map(addZero)
      .join('.');
}

export function formatPercent(percent: Decimal, toFixed = 2): string {
  const formatted = percent.abs()
                           .toFixed(toFixed)
                           .replace(/\./g, ',');
  return `${formatted}%`;
}

export function formatPercentAsNumber(percent: Decimal, toFixed = 2): number {
  return Number(percent.abs().toFixed(toFixed));
}

export function formatPercentWithMarks(percent: Decimal, toFixed = 2): string {
  const formatted = formatPercent(percent, toFixed);

  if (percent.greaterThan(0)) return `+ ${formatted}`;
  if (percent.lessThan(0)) return `- ${formatted}`;
  return `${formatted}`;
}

export function formatDate(date: Date, format = 'd.LL.yyyy'): string {
  if (!date) {
    return '';
  }
  return DateTime.fromJSDate(date).toFormat(format);
}

export const slugify = (str: string) => {
  return kebabCase(
    deburr(str)
      .toLowerCase()
      .replace(/(\d)\.(\d)/g, '$1$2')
      .replace(/[^a-z0-9]+/g, ' ')
  );
};